import React, { memo } from 'react';
import DataTableSkeleton from 'base/components/table/DataTable/DataTableSkeleton';
import Skeleton from 'base/components/Skeleton';
import LargeLabel from 'base/components/LargeLabel';


const ContactsTableSkeleton = () => (
  <DataTableSkeleton>
    <div className="rt-td" style={{ width: '83px', maxWidth: '83px' }}>
      <Skeleton
        width="53px"
        height="53px"
        borderRadius="100px"
        heightRandomness={0}
        widthRandomness={0}
      />
    </div>
    <div className="rt-td" style={{ maxWidth: '200px' }}>
      <LargeLabel><Skeleton width="80%" /></LargeLabel>
    </div>
    <div className="rt-td" style={{ maxWidth: '200px' }}>
      <LargeLabel><Skeleton width="80%" /></LargeLabel>
    </div>
  </DataTableSkeleton>
);

export default memo(ContactsTableSkeleton);
